import { redirectPath, USER_TYPES } from "src/constants";
import { UserType } from "src/types/users";

export const reRouteRelevantUser = (userData: UserType, isSso: boolean): string => {
  if (!userData.is_password_changed && !isSso) {
    return "/users/createuser";
  } else {
    if (USER_TYPES.MANUFACTURER.includes(userData.ref_type)){
      return redirectPath(userData)
    }else if (USER_TYPES.HCP.includes(userData.ref_type)) {
      return "/cases";
    } else {
      return "/cases";
    }
  }
};
